import React, { useState } from 'react'
import { Button } from '../ui'

export function ConfirmFlipButton({
  label,
  warning,
  confirmLabel,
  confirmingLabel,
  onConfirm,
  transitioning,
  variant = 'primary',
  cancelFirst = false,
}) {
  const [expanded, setExpanded] = useState(false)

  const handleConfirm = async () => {
    await onConfirm?.()
    setExpanded(false)
  }

  // Per design doc §6.1: the button that *triggers* a destructive flow is
  // a Secondary button; the in-confirm action carries the Danger variant.
  const triggerVariant = variant === 'danger' ? 'secondary' : 'primary'
  const confirmVariant = variant === 'danger' ? 'danger' : 'primary'

  return (
    <div style={styles.wrapper}>
      {!expanded ? (
        <Button variant={triggerVariant} onClick={() => setExpanded(true)}>
          {label}
        </Button>
      ) : (
        <div style={styles.expandedPanel}>
          <div style={styles.actions}>
            {cancelFirst && (
              <Button variant="secondary" onClick={() => setExpanded(false)}>Cancel</Button>
            )}
            <Button
              variant={confirmVariant}
              onClick={handleConfirm}
              loading={transitioning}
              loadingLabel={confirmingLabel}
            >
              {confirmLabel}
            </Button>
            {!cancelFirst && (
              <Button variant="secondary" onClick={() => setExpanded(false)}>Cancel</Button>
            )}
          </div>
          <p style={styles.warning}>{warning}</p>
        </div>
      )}
    </div>
  )
}

const styles = {
  wrapper: { display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 'var(--space-1)' },
  expandedPanel: {
    display: 'flex',
    flexDirection: 'column',
    gap: 'var(--space-2)',
    maxWidth: 280,
  },
  warning: {
    margin: 0,
    fontSize: 12,
    lineHeight: 1.4,
    color: 'var(--text-primary)',
  },
  actions: { display: 'flex', gap: 'var(--space-2)', justifyContent: 'flex-end' },
}
